import { useEffect } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CollabGenActionsExitModal = ({
  confirmModal
}) => {
  // Using onCancel from useGetCollabGenActionsFlowData rather than onClose
  // from FlowViewCanvas because we need to manipulate the local flow state
  const {
    onCancel,
    onSave,
    disableConfirmModal
  } = confirmModal;
  useEffect(() => {
    if (disableConfirmModal) {
      onCancel();
    }
  }, [disableConfirmModal, onCancel]);
  if (disableConfirmModal) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.collabGenActionsFlow.exitModal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onCancel
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.collabGenActionsFlow.exitModal.body"
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: onSave,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.collabGenActionsFlow.exitModal.confirmButtonText"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.collabGenActionsFlow.exitModal.cancelButtonText"
        })
      })]
    })]
  });
};
export default CollabGenActionsExitModal;